"use client";
import React from "react";

import { ReactComponent as Slinkedin } from "../assets/svg/LinkedIn.svg";
// import { ReactComponent as Sintasgram } from "../assets/svg/Instagram.svg";
import { ReactComponent as Stwitter } from "../assets/svg/Twitter.svg";
import { ReactComponent as Sfacebook } from "../assets/svg/Facebook.svg";

const shareOnTwitter = () => {
  const text = encodeURIComponent(
    "Delve into an enriching discussion in our latest blog post. Whether you're a seasoned professional or a curious enthusiast, this article offers something for everyone. Don't miss out!"
  );
  const url = encodeURIComponent(window.location.href);
  const shareUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
  window.open(shareUrl, "_blank");
};

const shareOnFacebook = () => {
  const url = encodeURIComponent(window.location.href);
  const summary = encodeURIComponent(
    "Delve into an enriching discussion in our latest blog post. Whether you're a seasoned professional or a curious enthusiast, this article offers something for everyone. Don't miss out!"
  );
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}&summary=${summary}`;
  window.open(shareUrl, "_blank");
};

const shareOnLinkedIn = () => {
  const title = encodeURIComponent("Check out this awesome blog post!");
  const summary = encodeURIComponent(
    "Delve into an enriching discussion in our latest blog post. Whether you're a seasoned professional or a curious enthusiast, this article offers something for everyone. Don't miss out!"
  );
  const url = encodeURIComponent(window.location.href);
  const shareUrl = `https://www.linkedin.com/shareArticle?mini=true&title=${title}&summary=${summary}&url=${url}`;
  window.open(shareUrl, "_blank");
};

const SocialShareButton = () => {
  return (
    <div className="blogPosts__body--container-socials">
      {/* <button type="button">
        <Sintasgram />
      </button> */}

      <button type="button">
        <Sfacebook onClick={shareOnFacebook} />
      </button>

      <button type="button" onClick={shareOnLinkedIn}>
        <Slinkedin />
      </button>

      <button type="button" onClick={shareOnTwitter}>
        <Stwitter />
      </button>
    </div>
  );
};

export default SocialShareButton;
